// src/components/Admin/AdminSidebar.js
import {Flex, Box, VStack, Link, Text, Icon } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaPlus, FaList, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';

const AdminSidebar = () => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <Box
      w="250px"
     bg="customDark"
      borderRight="1px solid"
      borderColor="gray.200"
      h="calc(100vh - 60px)"
      position="fixed"
    >
      <VStack spacing={4} p={4} align="stretch">
        <Link
          as={RouterLink}
          to="/admin/add-post"
          p={3}
          borderRadius="md"
          _hover={{ bg: 'blue.50', color: 'blue.600' }}
        >
          <Flex align="center">
            <Icon as={FaPlus} mr={3} />
            <Text>Add New Post</Text>
          </Flex>
        </Link>
        <Link
          as={RouterLink}
          to="/admin/posts"
          p={3}
          borderRadius="md"
          _hover={{ bg: 'blue.50', color: 'blue.600' }}
        >
          <Flex align="center">
            <Icon as={FaList} mr={3} />
            <Text>All Posts</Text>
          </Flex>
        </Link>
        <Link
          as={RouterLink}
          to="/admin/settings"
          p={3}
          borderRadius="md"
          _hover={{ bg: 'blue.50', color: 'blue.600' }}
        >
          <Flex align="center">
            <Icon as={FaCog} mr={3} />
            <Text>Settings</Text>
          </Flex>
        </Link>
        <Link
          p={3}
          borderRadius="md"
          onClick={handleLogout}
          _hover={{ bg: 'red.50', color: 'red.600', cursor: 'pointer' }}
        >
          <Flex align="center">
            <Icon as={FaSignOutAlt} mr={3} />
            <Text>Logout</Text>
          </Flex>
        </Link>
      </VStack>
    </Box>
  );
};

export default AdminSidebar;